import classNames from 'classnames';
import React from 'react';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import { IRegionShort } from 'api/region/types';
import { IResortPathInfo } from 'api/resort/types';
import { Resort } from './Resort';
import styles from './styles.module.scss';
import { Region } from './Region';

export const RelatedRegionResortList = ({
  title,
  resorts,
  regions,
  isFresh,
}: {
  title?: string,
  resorts: IResortPathInfo[],
  regions: IRegionShort[],
  isFresh: boolean,
}) => {
  // Manually filter out United States (hack)
  const filteredRegions = regions.filter((e) => e.uuid !== '429');

  const sortedResorts = resorts?.slice(0, 3);
  const sortedRegions = filteredRegions?.slice(0, (3 - sortedResorts?.length));

  return (
    <section className={classNames(styles.wrapper, !title && 'mt-3')}>
      {title && <h2>{title}</h2>}
      <div className={classNames(styles.wrapperBox, !isFresh && BLUR_CONTENT_STYLE_NAME)}>
        <div>
          {sortedResorts.map((item) => (
            <Resort
              isFresh={isFresh}
              key={item.uuid}
              resort={item}
            />
          ))}

          {sortedRegions.length > 0 && sortedRegions.map((item) => (
            <Region
              isFresh={isFresh}
              key={item.uuid}
              region={item}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
